import { userEmailExists } from '../graphql/users';
import { isEmail } from './validationUtils'
// import { organizationInDB } from '../graphql/organizationDetails';
// import { superAdminEditOrgRoute } from '../config/navigation/routes';

// const editUserURLConstant = '/memberadmin/edituser/';
// const editOrgURLConstant = '/superadmin/edit/organization/';

const emailIsValidAndUnsassigned = async value => {
  const isValidEmail = isEmail(value);
  if (isValidEmail) return isValidEmail;
  const { userByEmailStatus } = await userEmailExists(value);
  if (userByEmailStatus && userByEmailStatus.iconStatus) {
    // if (window.location.pathname.includes(editUserURLConstant)) {
    //   return window.location.pathname.split(editUserURLConstant)[1] ===
    //     userEmail.id
    //     ? undefined
    //     : 'This email is already taken!';
    // } else if (window.location.pathname.includes(editOrgURLConstant)) {
    //   return window.location.pathname.split(editOrgURLConstant)[1] ===
    //     userEmail.organizationId && userEmail.role.includes('admin')
    //     ? undefined
    //     : 'This email is already taken!';
    // }
    return 'This email is already taken';
  }
  return null;
  // return userEmail ? 'This email is already taken!' : undefined;
};
export default emailIsValidAndUnsassigned;


// export const emailIsValidAndUnsassigned2 = async (email, userId) => {
//   const { userEmail } = await userEmailExists(email);
//   if (userEmail && userEmail.iconStatus) {
//     return userId === userEmail.id
//       ? undefined
//       : 'This email is already taken!';
//   }
//   return null;
// };


// export const cageIsValidAndUnassigned = async value => {
//   const companyInfo = await organizationInDB(value);
//   if (companyInfo.organizationInDB) {
//     if (window.location.pathname.includes(editOrgURLConstant)) {
//       return window.location.pathname.split(
//         '/superadmin/edit/organization/',
//       )[1] === companyInfo.organizationInDB.id
//         ? undefined
//         : 'CAGE has already been Used!';
//     }
//   }
//   return undefined;
// };



// WEBPACK FOOTER //
// ./src/utils/asyncValidations.js